export const topTitleCardComponentContainer = () => {
  const components = document.querySelectorAll('.top-title-card-component-container');

  if (components) {
    components.forEach((component) => {
      const toggle = component.querySelector('[js-toggle-show-all]');
      const cardContainer = component.querySelector('[js-initial-show]');
      const count = cardContainer?.getAttribute('js-initial-show');

      if (count && cardContainer) {
        const countValue = parseInt(count, 10);
        Array.from(cardContainer.children).forEach((child, index) => {
          if (index >= countValue) {
            child.classList.add('hidden-card');
          }
        });
      }

      toggle?.addEventListener('click', () => {
        Array.from(cardContainer?.children ?? []).forEach((child) => {
          child.classList.remove('hidden-card');
        });
        toggle.classList.add('hidden');
      });
    });
  }
};
